import { render, staticRenderFns } from "./FakeLoading.vue?vue&type=template&id=ae9c1f1c"
import script from "./FakeLoading.vue?vue&type=script&lang=js"
export * from "./FakeLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports